<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Invoice Detail</small>
            <span v-if="this.invoice.isPaid" :class="`badge badge-success`" style="margin-left: 20px;"> Paid </span>
            <span v-if="this.invoice.isPaid === false" :class="`badge badge-danger`" style="margin-left: 20px;"> Not Paid </span>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <app-modal :elements="modalElements" v-on:confirm="updatePaid"></app-modal>
        <div class="row">
            <div class="form-group col-3">
                <label for="invoice-no">Invoice No</label>
                <input type="text" readonly class="form-control" v-model="invoice.invoiceNo" id="invoice-no" aria-describedby="action">
            </div>
            <div class="form-group col-3">
                <label for="issued-at">Issued At</label>
                <flat-pickr  disabled class="form-control" id="issued-at" v-model="invoice.date"></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="patient-name">Patient Name</label>
                <input type="text" readonly class="form-control" v-model="invoice.patientName" id="patient-name" aria-describedby="action">
            </div>
            <div class="form-group col-3">
                <label for="payment-method">Payment Method</label>
                <app-dropdown :id="'paymentMethod'" :keyName="'paymentMethod'" :model="invoice.paymentMethod" :lists="paymentMethod" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange"></app-dropdown>
            </div>
            <div class="form-group col-3">
                <label for="patient-name">Sender</label>
                <input type="text" class="form-control" v-model="invoice.paymentMethodRemarks" id="patient-name" aria-describedby="action">
            </div>
        </div>
        <app-datatable :type="'view'" :elements="dtElements" :collections="invoice.detail"></app-datatable>
        <app-total :total="invoice.subTotal" :discount="invoice.totalDiscount" :grandTotal="invoice.grandTotal"></app-total>
        <button type="button" class="btn btn-outline-success" @click="preview">Preview <i class="fas fa-print"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <button type="button" class="btn btn-outline-danger" data-toggle="modal" :data-target="`#${modalElements.modalId}`" style="margin-left: 20px;">Set as Paid<i class="far fa-cash"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { Invoice, InvoiceDetail } from '../../models/invoice'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import AppTeeth from '../../components/AppTeeth.vue'
import AppTotal from '../../components/AppTotal.vue'
import AppModal from '../../components/AppModal.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar, AppTeeth, AppTotal, AppModal
    },
    data() {
        return {
            invoice: {
                ...Invoice,
                detail: [InvoiceDetail],
            },
            modalElements: {
                modalId: 'invoice',
                title: 'Confirm',
                content: 'Are you sure to set this Invoice as Paid?',
                type: 'text-confirm'
            },
            paymentMethod: [],
            dtElements: [
                {
                    title: 'Date',
                    column: 'date',
                    type: 'date'
                },
                {
                    title: 'Treatment',
                    column: 'treatmentName',
                    type: 'text',
                },
                {
                    title: 'Anamnesa/Diagnosa',
                    column: 'description',
                    type: 'text',
                },
                {
                    title: 'Amount',
                    column: 'price',
                    type: 'number'
                },
                {
                    title: 'Discount',
                    column: 'discount',
                    type: 'number'
                },
            ],
        }
    },
    computed: {
    },
    async created() {
        const paymentApi = api('invoice/payment-method')
        this.paymentMethod = await paymentApi.get()

        if(this.$route.query.id !== undefined) {
            const ivApi = api('invoice/detail')

            const invoiceResult = await ivApi.getWithParams(this.$route.query.id)
            this.invoice = invoiceResult
        }
    },
    methods: {
        cancel() {
            this.$router.push({ name: 'invoice' })
        },
        preview() {
            if(this.$route.query.id !== undefined) {
                this.$router.push({
                    name: 'invoiceReport',
                    query: {
                        id: this.$route.query.id
                    }
                })
            }  
        },
        async updatePaid() {
            const ivApi = api('invoice/update-as-paid')
            await ivApi.update({id:this.$route.query.id, isPaid: true, paymentMethod: this.invoice.paymentMethod, paymentMethodRemarks: this.invoice.paymentMethodRemarks}, this.$route.query.id)
            this.$router.push({ name: 'invoice' })
        },
        selectChange(data) {
            const currentData = this.invoice
            this.invoice = {
                ...currentData,
                ...data
            }
        },
    }
}
</script>